module.exports = __webpack_public_path__ + "static/media/fly0011.2934f6f7.webp";